import { Component, ChangeDetectionStrategy, computed, inject } from '@angular/core';
import { ToolbarComponent } from '../../core/layout/components/toolbar/toolbar.component';
import { FooterComponent } from '../../core/layout/components/footer/footer.component';
import { NAV_ITEMS, NavItem } from '../../core/navigation/nav-items';
import { UserPermissionsService } from '../../core/auth/services/user-permissions.service';

import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-home',
  imports: [ToolbarComponent, FooterComponent, RouterModule],
  templateUrl: './home.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './home.component.scss',
})
export class HomeComponent {
  private readonly permissions = inject(UserPermissionsService);
  private readonly visibleNavItems = computed(() =>
    NAV_ITEMS.filter(
      (item) =>
        !item.hide && (!item.requiresAuditTrailAccess || this.permissions.canAccessAuditTrail()),
    ),
  );

  get navItems(): NavItem[] {
    return this.visibleNavItems();
  }

  trackByNav = (_: number, item: NavItem) => item.route + '|' + item.label;
}
